import { posthog } from 'posthog-js';
import { useCallback } from 'react';

const useSafeLogger = () => {
  const pgLogError = useCallback((text: string, data?: unknown) => {
    try {
      posthog.captureException(new Error(text), { data });
    } catch {
      // Silently ignore if PostHog is not yet initialised
    }
  }, []);

  const pgLogInfo = useCallback(
    (text: string, data?: Record<string, unknown>) => {
      try {
        posthog.capture(text, data);
      } catch {
        // Silently ignore if PostHog is not yet initialised
      }
    },
    [],
  );

  return { pgLogError, pgLogInfo };
};

export default useSafeLogger;
